import { initMain } from "./vue/controllers/main";
import { header } from "./vue/controllers/header";
import lazyload from "./features/lazy-load";
lazyload();
initMain([], {
  SpecialListingPager: () =>
    import("./vue/components/special-listing-pager/SpecialListingPager.vue"),
  TrendsHorizontal: () =>
    import("./vue/components/trends/TrendsHorizontal.vue"),
});
header();
